<template>
  <div>
    <v-subheader class=" py-4 grey lighten-4">
      <span class="text-h6 font-weight-light">SERBATOI</span>
    </v-subheader>
    <v-divider class="" />
    <v-list>
      <TankElement v-for="tank in tanks" :key="tank.id" :tank="tank" />
    </v-list>
  </div>
</template>

<script>
import TankElement from "./tank_mobile_element.vue";
import tank_mixin from "../mixin/tank_main_mixin";
export default {
  components: {
    TankElement,
  },
  mixins: [tank_mixin],
};
</script>